import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const addVendorSchema = (requireDefaultVendor: boolean) =>
  yup.object().shape({
    manufacturer: yup
      .object()
      .label(t('labelManufacturer'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelManufacturer'))),
    vendorAssociations: yup
      .array()
      .of(
        yup.object().shape({
          vendor: yup
            .object()
            .label(t('labelVendor'))
            .nullable()
            .required(getEmptyErrorMessage(t('labelVendor'))),
          contactGroupAddress: yup
            .object()
            .label(t('labelVendorLocation'))
            .nullable()
            .required(getEmptyErrorMessage(t('labelVendorLocation'))),
          isDefault: yup.boolean().required(getEmptyErrorMessage(t('labelIsDefault'))),
        })
      )
      .test('exactly-one-default', t('errorExactlyOneDefaultVendor'), function (value) {
        if (requireDefaultVendor) {
          return 1 === value?.filter((item) => item.isDefault).length;
        }

        return true;
      })
      .required()
      .min(1, getEmptyErrorMessage(t('labelVendors'))),
  });
